import React from 'react'
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';
import ColButton from '../../../Elements/ColButton';
import ErrorMessage from '../../../Elements/ErrorMessage';
import LoadingIcon from '../../../Elements/LoadingIcon';
import OverWindow from '../../../Elements/OverWindow';
import TaxService from '../../../Services/TaxService';


class AssociateTaxWindow extends React.Component 
{
    static defaultProps = {
        clickOnCancel: () => { },
        officeId: 1,
        entityTypeId: 11,
        entityId: 0,
    };

    constructor(props) 
    {
        super(props);
        this.state = {
            loading: true,
            taxList: [],
            saving: false,
        };
    }

    componentDidMount()
    {
        this.populateCommentListData();
    }

    async populateCommentListData()
    {
        this.setState({ loading: true });
        TaxService.GetTaxesByOfficeIdWithExclusion(this.props.officeId, this.props.entityTypeId, this.props.entityId)
            .then(result =>
            {
                let converted = TaxService.ConvertDBItem(result);
                converted.forEach(c => c.Selected = false);
                this.setState(
                    {
                        taxList: converted,
                        loading: false,
                    }
                );
            })
            .catch(error=>{
                ErrorMessage.SetErrorMessage("ATW48");
                this.setState({loading: false});
            });
    }

    renderTaxList() 
    {
        if (this.state.loading) return null;
        let rows = [];
        this.state.taxList.forEach((t, index) =>
        {
            if (this.state.showInactiveTaxes || !t.Inactive)
            {
                rows.push(
                    <tr key={"tr" + index} className="strippedrow">
                        <td key={"trtaxid"}>{t.TaxId}</td>
                        <td key={"trname"}>{t.Name}</td>
                        <td key={"tritemcode"}>{t.ItemCode}</td>
                        <td key={"trrate"}>{t.Rate}</td>
                        <td key={"trdesc"}>{t.Description}</td>
                        <td key={"tricons"}>
                            <input
                                type="checkbox"
                                checked={t.Selected}
                                onChange={e =>
                                {
                                    let tempList = [...this.state.taxList];
                                    tempList[index].Selected = e.target.checked;
                                    this.setState({ taxList: tempList });
                                }}
                            />
                        </td>
                    </tr>);
            }
        });
        return (
            <table className="container-fluid stripped table-hover">
                <thead>
                    <tr>
                        <th>TaxId</th>
                        <th>Name</th>
                        <th>Item Code</th>
                        <th>Rate</th>
                        <th>Description</th>
                        <th
                            className="pointer"
                            onClick={() =>
                            {
                                let tempTaxList = [...this.state.taxList];
                                tempTaxList.forEach(t => t.Selected = true);
                                this.setState({ ta: tempTaxList });
                            }}
                        >
                            Select All
                        </th>
                    </tr>
                </thead>
                <tbody >
                    {rows}
                </tbody>
            </table>
        );
    }

    GetSelectedIds()
    {
        return this.state.taxList.filter(t => t.Selected).map(t => t.TaxId);
    }

    clickOnSubmitButton()
    {
        this.setState({
            saving: true,
        });
        let selectedIds = this.GetSelectedIds();
        TaxService.AssociateTax(this.props.entityTypeId, this.props.entityId, selectedIds)
            .then(result =>
            {
                if (result.errorMessage)
                {
                    ErrorMessage.SetErrorMessage(result.errorMessage);
                    this.setState({saving: false});
                }
                else
                {
                    this.props.clickOnCancel(true);
                }
            })
            .catch(error =>
            {
                this.setState({
                    saving: false
                })
                ErrorMessage.SetErrorMessage("Error! ErrorCode: ATW132")
            });
    }

    renderButtons()
    {
        return (
            <ButtonFooterContainer>
                <ColButton
                    text="Cancel"
                    onClick={this.props.clickOnCancel}
                    disabled={this.state.saving}
                />
                <ColButton
                    text="Associate Tax "
                    type="submit"
                    icon={"fa-solid fa-save" + (this.state.saving ? " fa-spin" : "")}
                    disabled={this.state.saving }
                />
            </ButtonFooterContainer>
        );
    }

    render()
    {
        return (
            <OverWindow
                clickOnCancel={() => this.props.clickOnCancel(false)}
                title="Associate Tax"
                closeOnClickOutside={false}
            >
                <form
                    onSubmit={(e) =>
                    {
                        e.preventDefault();
                        this.clickOnSubmitButton();
                    }}
                >
                    {this.state.saving ||
                        <div className="container-fluid">
                            <div className="row">

                            </div>
                        </div>
                    }
                    {this.renderTaxList()}
                    <LoadingIcon loading={this.state.saving} />
                    
                    {this.renderButtons()}
                </form>
            </OverWindow>
        );

    }
}


export default AssociateTaxWindow;
